import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import AggregateHoldsGrid from '../components/bills/aggregate-holds-grid/grid';

export const HOLDS_AGGREGATE_TEST_ID = 'holds-aggregate-container';

const HoldsAggregate = (): JSX.Element => (
  <HHStack flex={1} minHeight="0" direction="column">
    <HHStack sx={{ paddingLeft: 6, paddingTop: 6 }}>
      <HHTypography hhVariant="section-title">High Dollar Holds</HHTypography>
    </HHStack>
    <AggregateHoldsGrid />
  </HHStack>
);

export default HoldsAggregate;
